export default "__VITE_ASSET__CDz6$5vd__"